import { Injectable } from "@angular/core";
import { Observable, Subscription } from "rxjs";
// import { RequestAddBankDto, RequestBankGetHistoryDto, RequestEditBankDto, ResponseBankAccountGetHistoryDto, ResponseGetBankMultipleDto } from "../../../../shared/nestjs/gd-only/dto/multibank.dto";
import { NestResponsesProvider } from "../../../../shared/nestjs/nest-responses";
import { NestApiProvider } from "../../../../shared/nestjs/nest-api";
import { PersonalNestApi } from "../../../../shared/nestjs/gd-only/services/personal.api";
import { GlobalServiceProvider } from "../../../../providers/global-service/global-service";
import { MedicalhistorySf6Api } from "../../../../shared/nestjs/gd-integrated/services/medicalhistory.api";
import { ResponseAddDto, ResponseSaveDto, ResponseDeleteDto } from "../../../../shared/nestjs/gd-integrated/dto/medicalhistory.dto";

@Injectable()
export class ProfileMedicalHistoryBloc {

  subscriptions: Array<Subscription> = [];

  constructor(
    public nestResponse: NestResponsesProvider,
    public nestApiProvider: NestApiProvider,
    public personalApi: PersonalNestApi,    
    public globalService: GlobalServiceProvider,
    public medicalhistorySf6Api : MedicalhistorySf6Api
  ) { 
  }

  listing(payload): Observable<any> {
    console.log('BLOC | listing', payload)
		return this.medicalhistorySf6Api.listing(
      payload.empId,
			payload.lang
		);
	}

	add(data): Observable<ResponseAddDto> {
		return this.medicalhistorySf6Api.add(data);
	}

	save(data): Observable<ResponseSaveDto> {
		return this.medicalhistorySf6Api.save(data);
	}

	delete(data): Observable<ResponseDeleteDto> {
		return this.medicalhistorySf6Api.delete(data);
  }

  getPersonal(payload): Promise<any> {
    return new Promise((resolve, reject) => {
      this.personalApi.getPersonal(payload).subscribe(
        async (result) => {
          console.log('BLOC | getPersonal', result)
          let resultData = await this.globalService.convertObjToCamelCase(result.data);
          console.log('BLOC | resultData', resultData)
          resolve(resultData);
        }, error => {
          reject(error);
          console.log('getPersonal', error)
        }
      )
    })
  }

  doctor(): Observable<any> {
    console.log('BLOC | doctor')
    return this.medicalhistorySf6Api.doctor();
  }

  hospital(): Observable<any> {
    console.log('BLOC | hospital')
    return this.medicalhistorySf6Api.hospital();
  }

  disease(lang): Observable<any> {
    console.log('BLOC | disease', lang)    
    return this.medicalhistorySf6Api.disease(lang);
  }

  currency(): Observable<any> {
    console.log('BLOC | currency')    
    return this.medicalhistorySf6Api.currency();
  }

  updatePost(data): Observable<any> {
		return this.medicalhistorySf6Api.updatePost(data);
  }

  dispose() {
    this.subscriptions.forEach((sub) => sub.unsubscribe);
  }
  
  medicalType(): Observable<any> {
    return this.medicalhistorySf6Api.medicalType();
  }
}


// WEBPACK FOOTER //
// ./src/bloc/feature/profile/profile-medical/profile-medicalhistory.bloc.ts